// extracted by css-extract-rspack-plugin
export default {"cls1":"FallbackBulkDownloadUpsellModalControl-cls1_ZYn","cls2":"FallbackBulkDownloadUpsellModalControl-cls2_Eg- FallbackBulkDownloadUpsellModalControl-cls1_ZYn"};